import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['template', 'list', 'copyPreviousItem'];

  add() {
    if (this.hasCopyPreviousItemTarget) {
      console.debug("copy previous sub item:", this.copyPreviousItemTarget.checked);
    }
    const self = this;
    const ts = new Date().getTime();
    const newRow = this.templateTarget.content.cloneNode(true);
    $(newRow).find("template").each(function () {
      $(this.content).find('input, select, textarea').each(function () {
        self.replaceId(this, ts);
      });
    });

    $(newRow).find('input, select, textarea').each(function() {
      self.replaceId(this, ts);
    });

    $(newRow).find('li').addClass('nestedfield-item');
    this.listTarget.appendChild(newRow);
    event.preventDefault();
  }

  remove() {
    const list = $(event.target).closest('.nestedfield-item');
    list.find('input[name*=_destroy]').val('true');
    list.slideUp(600);
    event.preventDefault();
  }

  replaceId(input, ts) {
    $(input).attr('name', function () {
      return $(input).attr('name').replace('new_record', ts);
    });
    if ($(input).attr('id')) {
      $(input).attr('id', function () {
        return $(input).attr('id').replace('new_record', ts);
      });
    }
    $(input).addClass("new");
  }
};
